export default __webpack_public_path__ + "static/media/danger.c17b0039.svg";